<template>
  <v-container fluid class="login-container">
    <v-row justify="center" align="center" class="fill-height">
      <v-col
        cols="12"
        sm="10"
        md="8"
        lg="5"
        xl="4"
        class="d-flex justify-center"
      >
        <v-card class="login-card" elevation="8">
          <v-card-title class="text-center pa-3">
            <div class="text-h5 font-weight-bold text-primary mb-0">
              RCS 
            
              BMS
            </div>
          </v-card-title>

          <v-card-text class="pa-4">
            <v-form
              ref="loginForm"
              v-model="valid"
              @submit.prevent="handleLogin"
            >
              <!-- Email Input -->
              <v-text-field
                v-model="email"
                :rules="emailRules"
                label="Email ID"
                prepend-inner-icon="mdi-email-outline"
                type="email"
                variant="outlined"
                density="compact"
                class="mb-2"
                :disabled="otpSent"
                required
              ></v-text-field>

              <!-- OTP Input (shown after email is sent) -->
              <v-otp-input
                v-if="otpSent"
                v-model="otp"
                length="6"
                variant="outlined"
                density="compact"
                class="mb-2"
                :rules="otpRules"
              ></v-otp-input>

              <!-- Resend OTP Link -->
              <div v-if="otpSent" class="text-center mb-2">
                <v-btn
                  text
                  color="primary"
                  variant="text"
                  size="small"
                  :disabled="resendDisabled"
                  @click="resendOTP"
                >
                  Resend OTP
                  <span v-if="countdown > 0" class="ml-1"
                    >({{ countdown }}s)</span
                  >
                </v-btn>
              </div>

              <!-- Submit Button -->
              <v-btn
                :disabled="!valid || loading"
                :loading="loading"
                color="primary"
                type="submit"
                size="default"
                block
                class="mt-2"
              >
                {{ otpSent ? "Verify OTP" : "Send OTP" }}
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Snackbar Component -->
    <SnackbarComponent
      v-model="snackbar.show"
      :message="snackbar.message"
      :color="snackbar.color"
    />
  </v-container>
</template>

<script>
import { confirmSignIn, signIn, signOut } from "aws-amplify/auth";
import SnackbarComponent from "@/components/Extras/Snackbar.vue";

export default {
  name: "LoginPage",
  components: {
    SnackbarComponent,
  },
  data() {
    return {
      valid: false,
      email: "",
      otp: "",
      otpSent: false,
      loading: false,
      countdown: 0,
      resendDisabled: false,
      snackbar: {
        show: false,
        message: "",
        color: "primary",
      },
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "Email must be valid",
      ],
      otpRules: [
        (v) => !!v || "OTP is required",
        (v) => (v && v.length === 6) || "OTP must be 6 digits",
        (v) => /^\d+$/.test(v) || "OTP must contain only numbers",
      ],
    };
  },
  async mounted() {
     console.log("dev")
    try {
      await signOut({ global: true });
      // console.log("in")
    } catch (error) {
      console.error("Error signing out:", error);
    }
  },
  methods: {
    async handleLogin() {
      if (this.loading) return;

      if (!this.$refs.loginForm.validate()) {
        return;
      }

      this.loading = true;

      try {
        if (!this.otpSent) {
          // Send OTP
          await this.sendOTP();
        } else {
          // Verify OTP
          await this.verifyOTP();
        }
      } catch (error) {
        this.showSnackbar(
          error.message || "An error occurred. Please try again.",
          "error"
        );
      } finally {
        this.loading = false;
      }
    },
    async sendOTP() {
      try {
         await signIn({
          username: this.email,
          options: {
            authFlowType: "CUSTOM_WITHOUT_SRP",
          },
        });
        // console.log(logInResult);
        this.otpSent = true;
        this.showSnackbar("OTP sent Successfully", "success");
      } catch (err) {
        console.log(err);
        if (err.message === "There is already a signed in user.") {
          this.loading = false;
          await signOut({ global: true });
          // this.sendOTP();
        } else {
          this.loading = false;
          this.showSnackbar("Couldn't find your account", "error");
        }
      }
    },
    async verifyOTP() {
      try {
        const user = await confirmSignIn({
          challengeResponse: this.otp,
        });
        this.loading = false;
        if (user.isSignedIn === true) {
          this.$router.push("/landing/organization");
          this.$store.dispatch("setUser", { email: this.email });
        } else {
          this.showSnackbar("Invalid OTP", "error");
          this.otp = "";
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
        if (
          error.message ==
          "Invalid version in Lambda response. Version should be 1"
        ) {
          this.showSnackbar("Invalid OTP", "error");

          this.otp = "";
        } else if (error.message == "Invalid session for the user.") {
          this.showSnackbar(
            "Multiple Attempts, Please Resend OTP and Login again",
            "error"
          );

          this.otp = "";
        } else {
          this.showSnackbar(error.message, "error");
          this.otp = "";
        }
      }
    },
    async resendOTP() {
      if (this.resendDisabled) return;

      this.loading = true;
      this.otp = "";

      try {
        await this.sendOTP();
      } catch (error) {
        this.showSnackbar(
          error.message || "Failed to resend OTP. Please try again.",
          "error"
        );
      } finally {
        this.loading = false;
      }
    },
    showSnackbar(message, color = "primary") {
      this.snackbar.message = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    startCountdown() {
      this.countdown = 60;
      this.resendDisabled = true;

      const timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(timer);
          this.resendDisabled = false;
        }
      }, 1000);
    },
  },
};
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.login-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
      circle at 20% 50%,
      rgba(5, 150, 105, 0.1) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 80% 80%,
      rgba(5, 150, 105, 0.08) 0%,
      transparent 50%
    );
  pointer-events: none;
}

.login-card {
  border-radius: 12px;
  overflow: hidden;
  max-width: 420px;
  width: 100%;
  margin: 0 auto;
}

:deep(.v-text-field) {
  margin-bottom: 8px;
}

:deep(.v-btn) {
  text-transform: none;
  letter-spacing: 0.5px;
}
</style>

